import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Grid } from 'react-material-responsive-grid';
import IndCircProgress from 'shared/components/IndeterminateCircularProgress';
import { TransitionGroup } from 'react-transition-group';
import FadeTransition from 'shared/components/FadeTransition';
import { Scrollbars } from 'react-custom-scrollbars';
import sharedStyles from 'shared/styles.css';
import styles from './styles.css';
import CategoryCard from './CategoryCard';

/**
 * Display a list of products as Product Cards in a flexbox.
 * @param {props} See Prop validation
 */
class CategoriesCardDisplay extends React.Component {
	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps) {
		if (this._scrollbarsRef != null) {
			this._scrollbarsRef.scrollTop(0);
		}
	}

	/**
	 * If additional products are being fetched display an indeterminate
	 * circular progress bar.
	 * @param {boolean} isFetching
	 */
	loadProgressBar = isFetching => (isFetching ? <IndCircProgress /> : null);

	/**
	 * Ref callback for the Scrollbars component.
	 * When the Scrollbars component mounts, set scroll position to initialScrollPosition and save ref.
	 */
	initialScroll = ref => {
		if (ref != null) {
			ref.scrollTop(this.props.initialScrollPosition);
			this._scrollbarsRef = ref;
		}
	};

	render() {
		const { isFetching, categories, scrollHandler } = this.props;
		return categories.length === 0 ? (
			this.loadProgressBar(isFetching)
		) : (
			<div className={sharedStyles.productSection} id="infinite-scroll">
				<Scrollbars ref={this.initialScroll} onScrollFrame={event => scrollHandler(event)}>
					<div className={sharedStyles.productScroll}>
						<Grid>
							<Row>
								{/* Fade in/fade out the product cards */}
								{categories.map(category => (
									<Col
										key={category.categoryId}
										xs4={4}
										xs8={4}
										sm12={4}
										md={4}
										lg={3}
										xl={3}
										className={sharedStyles.cardCol}
									>
										<TransitionGroup>
											<FadeTransition>
												<div className={styles['category-grid-card']}>
													<CategoryCard
														id={category.categoryId}
														cat={category.name}
														pictureUrl={category.pictureUrl}
													/>
												</div>
											</FadeTransition>
										</TransitionGroup>
									</Col>
								))}
							</Row>
							{this.loadProgressBar(isFetching)}
						</Grid>
					</div>
				</Scrollbars>
			</div>
		);
	}
}

CategoriesCardDisplay.propTypes = {
	initialScrollPosition: PropTypes.number,
	categories: PropTypes.arrayOf(
		PropTypes.shape({
			categoryId: PropTypes.number,
			name: PropTypes.string,
			description: PropTypes.string,
			pictureUrl: PropTypes.string,
			url: PropTypes.string,
		}),
	).isRequired,
	isFetching: PropTypes.bool.isRequired,
	scrollHandler: PropTypes.func.isRequired,
};

CategoriesCardDisplay.defaultProps = {
	initialScrollPosition: 0,
};

export default CategoriesCardDisplay;
